import React, { useState } from 'react'
import DateInputWrapper from './date-input-wrapper'
import SelectInputWrapper from './select-input-wrapper'
import Fields from './fields'
import { ajaxGet } from '../../ajax'
import moment from 'moment'

export default function AdditionalGames(props) {
  const { unregister, register, errors, setValue, getValues, locationId, fields, subGames, onAdd, onRemove, onChange, multiSelect, onLoading } = props

  const onChangeDate = (date, index) => {
    onLoading(true)
    ajaxGet(`/admins/locations/${locationId}/times.json?date=${date.format('MM/DD/YYYY')}`)
    .then(response => { if (response.ok) return response.json() })
    .then(json => {
      onChange(index, {date: date, hours: json.hours})
      onLoading(false)
    })
  }

  const onChangeField = (index, value) => {
    if (!multiSelect) return onChange(index, {field: value})

    const currentFields = `${subGames[index].field}`.split(',')
    const fields = currentFields.indexOf(value) == -1 ? currentFields.concat(value) : currentFields.filter(e => e !== value)
    if (fields.length > 0) onChange(index, {field: fields.join()})
  }

  const handleSubGameRemove = (index) => {
    const currentTimes = [...getValues('times')]

    currentTimes.splice(index + 1, 1)
    currentTimes.splice(0, 1)

    for (var i = index + 1; i < getValues('times').length; i++) {
      unregister(`times[${i}]`)
    }
    for (var i = 0; i < currentTimes.length; i++) {
      register(`times[${i + 1}]`, { required: 'Is required' })
      setValue(`times[${i + 1}]`, currentTimes[i], { shouldValidate: true })
    }

    onRemove(index)
  }

  const showSubGame = (subGame, index) => {
    return <div key={index}>
      <br/>
      <div className='col-sm-7'>
        <DateInputWrapper
          label='Date'
          onChange={(date) => onChangeDate((date || moment()), index)}
          date={moment(new Date(subGame.date))}
          minDate={moment()}
        />
      </div>
      <div className='col-sm-3'>
        <SelectInputWrapper
          {...register(`times[${index + 1}]`, { required: 'Is required' })}
          label='From'
          options={subGame.hours} 
          error={errors.times && errors.times[index + 1]}
          onChange={(e) => setValue(`times[${index + 1}]`, e.target.value, { shouldValidate: true })}
        />
      </div>
      <div className='col-sm-2'>
        <label className='game-form-label'>
          &nbsp;
          <div className='btn btn-default form-control' onClick={() => handleSubGameRemove(index)}>
            <i className='fa fa-trash'></i>
          </div>
        </label>
      </div>
      { fields && 
        <Fields
          multiSelect
          selected={subGames[index].field} 
          fields={fields} 
          fieldIndex={index + 1}
          onChangeField={(value) => onChangeField(index, value)}
        /> 
      }
    </div>
  }

  return <div className='row additional'>
    {
      subGames.map((game, index) => showSubGame(game, index))
    }
    <div className='col-sm-12'>
      <div className='btn btn-link' onClick={onAdd}>
        <i className='fa fa-plus'></i>
        &nbsp;Additional Reservations
      </div>
    </div>
  </div>
}
